<template>
  <el-table-column
    prop="creator_user_name"
    sortable="custom"
    label="Létrehozó"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'creator_user_name',
  };
</script>
